import { render, staticRenderFns } from "./CollectionOlapic.vue?vue&type=template&id=3f35f3f8&name=collection-olapic&"
import script from "./CollectionOlapic.vue?vue&type=script&lang=js&"
export * from "./CollectionOlapic.vue?vue&type=script&lang=js&"
import style0 from "./CollectionOlapic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports